import { Modal, Typography, Button } from "@plum-xoxo/admin-dsm";
import React from "react";
import {
  DownloadIcon,
  QrCodeIcon,
  CheckMarkIcon,
  MobileProtectionIcon,
  BubbleChatIcon,
  BarCodeIcon,
} from "./mfaIcons";

import styled from "styled-components";

const Rectangle = styled.div`
  width: ${(props) => props.width || "40px"};
  height: ${(props) => props.height || "40px"};

  background-color: #f6f7f9;
  border-radius: ${(props) => props.borderRadius || "8px"};
`;

const LearnMorePopup = ({ showLearnMorePopup, setShowLearnMorePopup }) => {
  const data = {
    authenticator: {
      title: "Secure Your Account using Authenticator App",
      description:
        "Just three simple steps to enhance your security with two step authentication",
      steps: [
        {
          icon: DownloadIcon,
          title: "Step 1: Download an Authenticator App",
          description:
            "Get Google Authenticator, Microsoft Authenticator or any preferred authenticator app on your phone.",
        },
        {
          icon: QrCodeIcon,
          title: "Step 2: Scan the QR Code",
          description:
            'Open the app, select "Add Account", and scan the QR code.',
        },
        {
          icon: BarCodeIcon,
          title: "Step 3: Enter the Authentication Code",
          description: "Enter the 6-digit code to complete setup.",
        },
      ],
    },
    mobile: {
      title: "Secure Your Account using Mobile App",
      description:
        "Just three simple steps to enhance your security with two step authentication",
      steps: [
        {
          icon: MobileProtectionIcon,
          title: "Step 1: Add Your Mobile Number",
          description: "Enter your mobile number where you’d like to receive security codes.",
        },
        {
          icon: BubbleChatIcon,
          title: "Step 2: Receive & Enter the OTP",
          description: "You’ll get a one-time password (OTP) via SMS. Enter it to verify your number.",
        },
        {
          icon: CheckMarkIcon,
          title: "Step 3: Complete Setup",
          description: "Once verified, your phone number will be linked for two-step authentication.",
        },
      ],
    },
  };
  const onClose = () => {
    setShowLearnMorePopup(false);
  };
  if (!showLearnMorePopup) return null;

  return (
    <div>
      <Modal isOpen={showLearnMorePopup} onClose={onClose} size="md">
        <div className="p-4">
          <Typography.H2 color="dark" shade="c300">
            {data[showLearnMorePopup]?.title || ""}
          </Typography.H2>
          <Typography.HelperText
            color="dark"
            shade="c200"
            className="mt-8 mb-24"
          >
            {data[showLearnMorePopup]?.description || ""}
          </Typography.HelperText>

          <div>
            {data[showLearnMorePopup]?.steps.map((step, index) => (
              <div
                key={index}
                className="step-item mb-24 d-flex align-items-start"
              >
                <Rectangle className="mr-16 d-flex align-items-center justify-content-center">
                  <step.icon />
                </Rectangle>
                <div>
                  <Typography.LabelText
                    color="dark"
                    shade="c300"
                    className="mb-4"
                  >
                    {step.title}
                  </Typography.LabelText>
                  <Typography.HelperText color="dark" shade="c200">
                    {step.description}
                  </Typography.HelperText>
                </div>
              </div>
            ))}
          </div>

          <Rectangle
            className=" mt-32 px-16 py-8"
            width="100%"
            height="auto"
            borderRadius="4px"
          >
            <Typography.HelperText color="dark" shade="c200" className="mb-0">
              This extra step ensures only you can log in, even if someone knows
              your password.
            </Typography.HelperText>
          </Rectangle>
          <div className="text-right mt-32">
            <Button onClick={onClose}>OK, Got It</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default LearnMorePopup;
